import { StudentType } from '@wonderschool/common-base-types';
import { TFunction } from 'i18next';
import { saveCSV } from '../../common';
import { phoneNumberParse } from '../../helpers/utils';
// eslint-disable-next-line no-restricted-imports
import moment from 'moment';
import { DefaultDateFormat } from '../../helpers/dates';
import { getFamilyInviteStatusLabel, getFamilyRelationshipLabel } from './familyDirectoryExportUtils';

export async function generateParentsListingCSV(
  studentsListCSVReport: StudentType[],
  allRooms: any,
  studentBillingDetails: string | any[],
  locationName: string,
  t: TFunction
) {
  const headers = PARENTS_COLUMNS.map((column) => t(column.headerKey)).join(',') + '\n';
  const date = moment(new Date()).format(DefaultDateFormat);
  const selectedLocation = locationName;
  const filename = `Contact_list_${selectedLocation}_${date}.csv`;
  const body = studentsListCSVReport
    .map((student: any) => {
      if (student.family && Object.values(student.family).length > 0) {
        return Object.values(student.family)
          .map((family: any) => {
            return [
              student?.displayName,
              student?.rooms ? allRooms.find((room: any) => room.id === student.rooms[0])?.name : '',
              `${family?.displayName} (${getFamilyRelationshipLabel(family, t)})`,
              family?.email ? family?.email : '-',
              family.phone ? phoneNumberParse(family?.phone) : '-',
              family?.allowLoginWithPin === true ? t('common.yes') : t('common.no'),
              family?.email === student?.responsibleForBilling?.email ? t('common.primaryPayer') : '-',
              family?.email === student?.responsibleForBilling?.email && studentBillingDetails?.includes(student.id)
                ? t('parentsListing.autoPay')
                : '',
              family?.stats?.appLastOpened ? t('common.yes') : t('common.no'),
              getFamilyInviteStatusLabel(family?.status, t),
            ].join(',');
          })
          .join('\n');
      }
    })
    .filter((s: any) => !!s)
    .join('\n');
  const csv = headers + body;
  saveCSV(csv, filename);
}

const PARENTS_COLUMNS = [
  { headerKey: 'familyDirectory.export.nameColumn', dataKey: 'displayName' },
  { headerKey: 'familyDirectory.export.roomColumn', dataKey: 'room' },
  { headerKey: 'familyDirectory.export.familyContactsColumn', dataKey: 'FamilyandContacts' },
  { headerKey: 'familyDirectory.export.emailColumn', dataKey: 'Email' },
  { headerKey: 'familyDirectory.export.phoneColumn', dataKey: 'PhoneNumber' },
  { headerKey: 'familyDirectory.export.pickupColumn', dataKey: 'Pickup' },
  { headerKey: 'familyDirectory.export.paymentColumn', dataKey: 'Payment' },
  { headerKey: 'familyDirectory.export.autopayColumn', dataKey: 'Autopay' },
  { headerKey: 'familyDirectory.export.mobileAppColumn', dataKey: 'App' },
  { headerKey: 'familyDirectory.export.inviteStatusColumn', dataKey: 'Invite' },
];
